<template>
        <div class="right_box">
            <div class="right_title">
                {{ TitleName }}
            </div>
            <div class="right_news_box">
                <div class="news_item hvr-underline-from-center" v-for="(item, index) in list" :key="index" @click="showMeetingDetail( item )">
                    <img src="../../assets/static/index/default.png" alt="">
                    <div class="news_info">
                        <div class="news_title">
                            <div class="title_name">
                                {{ item.meetingName }}
                            </div>
                             <div class="status_left">
                                <span class="iconfont icon-yijieshu"></span> <span>{{ item.meetingStatusName }}</span>
                            </div>
                        </div>
                        <div class="dept">
                            {{ item.deptName }}
                        </div>
                        <div class="time desc">
                            <span class="iconfont icon-shijian"></span>时间: {{ item.startTime }}
                        </div>
                        <div class="address desc">
                            <span class="el-icon-location-outline"></span>地点: {{ item.meetingAddress }}
                        </div>
                        <div class="prople desc">
                            <span class="el-icon-user"></span>参会人数: {{ item.memberCount }}
                        </div>
                        <div class="status-line">
                           
                            <div class="show_info">
                                <span>查看详情 ></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <no-more v-if="list.length == 0 "></no-more>

            <!-- fenye -->
            <div class="page_box" style="text-align:right;" v-if="list && list.length">
                <el-pagination
                background
                layout="prev, pager, next"
                :page-size="pageSize"
                :current-page="page"
                @current-change="pageChange"
                :total="totalPage * pageSize">
                </el-pagination>
            </div>

        </div>
</template>

<script>
    export default {
        data() {
            return {
                list: [],
                totalPage: 0,
                pageSize: 10,
                page: 1,
            }
        },
        computed: {
            TitleName () {
                return this.$route.query.title
            },
            type () {
                return this.$route.params.type
            },
            meetingType () {
                return this.$route.query.meetingType ? this.$route.query.meetingType : ""
            },
            buildingPartyType () {
                return this.$route.query.buildingPartyType ? this.$route.query.buildingPartyType : ""
            },
            threeMeetingType () {
                return Number( this.$route.params.type )
            },
            reqUrl () {
                if ( this.threeMeetingType != null  && !this.meetingType && !this.buildingPartyType ) {
 
                    return "/lencon/pc/activity/three_meeting_list"
                } else if ( this.threeMeetingType == 0 && this.meetingType && this.buildingPartyType ) {

                    return "/lencon/pc/activity/meeting_list"
                }
            },
            deptId () {
                return this.$route.params.id
            },
            reqInfo () {
                if ( this.threeMeetingType != null && !this.meetingType && !this.buildingPartyType ) {
                    return {
                        threeMeetingType: this.threeMeetingType,
                        deptId: Number(this.deptId) ? Number(this.deptId) : 0,
                        pageSize: this.pageSize,
                        pageNum: this.page,
                    }
                    // return "/lencon/pc/activity/three_meeting_list"
                } else if ( this.threeMeetingType == 0 && this.meetingType && this.buildingPartyType ) {
                    return {
                        meetingType: this.meetingType,
                        buildingPartyType: this.buildingPartyType,
                        deptId: Number(this.deptId) ? Number(this.deptId) : 0,
                        pageSize: this.pageSize,
                        pageNum: this.page
                    }
                    // return "/lencon/pc/activity/meeting_list"
                }
            },
            activeMain () {
                return this.$route.query.activeMain
            }
            
        },
        watch: {
            threeMeetingType ( newVal, oldVal) {
                // console.log( newVal )
                this.page = 1
                this.getList()
            },
            meetingType ( newVal, oldVal ) {
                // console.log( newVal )
                this.page = 1   
                this.getList()
            },
            type () {
                this.getList()
            },
            activeMain () {
                this.getList()
            }

        },
        mounted() {
            console.log( this.threeMeetingType )
            this.getList()
        },
        methods: {
            // 会议详情
            showMeetingDetail ( item ) {
                this.$router.push({
                    path: `/MeetingDetail/${ item.meetingId }`,
                    // cate_id: item.cate_id 
                })
            },

            // 获取列表
            async getList () {
                this.list = []
                let res = await this.$axios.post( this.reqUrl, this.reqInfo )
                if ( res.data.code == 1 ) {
                    this.list = res.data.data
                    this.totalPage = res.data.totalPage
                }
            },
            // 页码变化
            pageChange ( e ) {
                console.log( e )
                this.page = e 
                this.getList()
            },
        }
    }
</script>
<style>
.el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #2767c4 ;
}
.hvr-underline-from-center::before {
    background: #2767c4  !important;
}
</style>

<style lang="scss" scoped>

    .right_box {
        width: 924px;
        background-color: #fff;
        border-radius: 0 10px 10px 0;
        // padding: 30px;
        box-sizing: border-box;
        overflow: hidden;
        .right_title {
            font-size: 20px;
            font-weight: bold;
            padding-bottom: 10px;
            border-bottom: 1px solid #eeeeee;
            
        }
        .right_news_box {
            width: 100%;
            .news_item {
                display: flex;
                margin: 20px 0;
                cursor: pointer;
                img {
                    width: 275px;
                    height: 195px;
                }
                .news_info {
                    margin-left: 20px;
                    flex: 1;
                    .news_title {
                        font-weight: bold;
                        font-size: 18px;
                        line-height: 40px;
                        width: 100%;
                        display: flex;
                        .title_name {
                            
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            width:500px;
                        }
                        .status_left {
                            color: #2767c4 ;
                            width: 120px;
                            text-align: right;
                        }
                    }
                    .dept {
                        font-size: 16px;
                        line-height: 30px;
                        color: #b3b3b3;
                    }
                    .desc {
                        font-size: 14px;
                        color: #b3b3b3;
                        line-height: 30px;
                        span {
                            margin-right: 10px;
                        }
                    }
                    .status-line {
                        line-height: 40px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        width: 100%;
                        .show_info {
                            width: 100%;
                            text-align: right;
                            color: #b3b3b3;
                        }
                    }
                }
            }
        }
    }

</style>